var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.94411C0 3.81239 0 2.74653 0.251677 2.38795C0.503354 2.02937 1.50555 1.68631 3.50994 1.0002L3.89182 0.869486C4.93666 0.511834 5.45907 0.333008 6 0.333008C6.54093 0.333008 7.06335 0.511834 8.10819 0.869486L8.49006 1.0002C10.4945 1.68631 11.4966 2.02937 11.7483 2.38795C12 2.74653 12 3.81239 12 5.94411V6.99391C12 10.7526 9.17402 12.5767 7.40096 13.3512C6.91999 13.5613 6.67951 13.6663 6 13.6663C5.32049 13.6663 5.08001 13.5613 4.59904 13.3512C2.82597 12.5767 0 10.7526 0 6.99391V5.94411ZM6 3.83301C6.27614 3.83301 6.5 4.05687 6.5 4.33301V6.99967C6.5 7.27582 6.27614 7.49967 6 7.49967C5.72386 7.49967 5.5 7.27582 5.5 6.99967V4.33301C5.5 4.05687 5.72386 3.83301 6 3.83301ZM6 9.66634C6.36819 9.66634 6.66667 9.36786 6.66667 8.99967C6.66667 8.63148 6.36819 8.33301 6 8.33301C5.63181 8.33301 5.33333 8.63148 5.33333 8.99967C5.33333 9.36786 5.63181 9.66634 6 9.66634Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.91f5070d41d75ff144418b6b94e5db25.svg";
export { ForwardRef as ReactComponent };